import { render, staticRenderFns } from "./learningEmpty.vue?vue&type=template&id=5b0bca36&scoped=true&"
import script from "./learningEmpty.vue?vue&type=script&lang=js&"
export * from "./learningEmpty.vue?vue&type=script&lang=js&"
import style0 from "./learningEmpty.vue?vue&type=style&index=0&id=5b0bca36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0bca36",
  null
  
)

export default component.exports